import React from "react";
import BearIcon from "./assets/images/bear.avif";
import "./reset.css";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      <img src={BearIcon} alt="bear" />
    </div>
  );
};

export default App;
